import React from 'react';
import {IOrderModel} from '../../../../../src/@interfaces/models/Order/IOrderModel';
import {IOrderTaskModel, OrderTaskPossibleTypes} from '../../../../../src/@interfaces/models/Order/IOrderTaskModel';

export type TaskRepresentationProps<TaskType extends OrderTaskPossibleTypes> = {
    formId: string,
    order: IOrderModel,
    task: IOrderTaskModel<TaskType>,
    isDisabled?: boolean,
};

export default function VoidTask<TaskType extends OrderTaskPossibleTypes>(
        props: TaskRepresentationProps<TaskType>// eslint-disable-line
) {
    return <></>;
}
